import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const ContentWrapper = styled.div`
	z-index: var(--z-index-10);
	max-height: 90dvh;

	${(props) =>
		!props.disableMobileView &&
		`@media ${Breakpoints.mobile} {
			transform: unset !important;
			top: unset !important;
			right: unset !important;
			left: 0 !important;
			bottom: 0 !important;
			padding: 0 !important;
			width: 100%;

			> div {
				width: 100% !important;
			}
		}`}
`;

export const Shadow = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: fixed;
	inset: 0;
	background-color: var(--modal-fullscreen-bg);
	z-index: var(--z-index-10);

	@media ${Breakpoints.mobile} {
		justify-content: flex-end;
	}
`;

export const Arrow = styled.div`
	width: 2rem;
	height: 2rem;
	position: absolute;
	background: transparent;
	visibility: hidden;

	&::before {
		content: '';
		visibility: visible;
		position: absolute;
		background: transparent;
		width: 2rem;
		height: 2rem;
		border-left: 1rem solid transparent;
		border-right: 1rem solid transparent;
		border-top: 1rem solid ${(props) => props.arrowColor ?? 'var(--background-5)'};
	}

	&[data-popper-placement^='left'] {
		right: -1.9rem;

		&::before {
			transform: rotate(-90deg);
		}
	}
	&[data-popper-placement^='right'] {
		left: -1.9rem;

		&::before {
			transform: rotate(90deg);
		}
	}
	&[data-popper-placement^='top'] {
		bottom: -1.9rem;
	}
	&[data-popper-placement^='bottom'] {
		top: -1.9rem;

		&::before {
			transform: rotate(180deg);
		}
	}
`;
